import React from 'react';
import ReactDOM from 'react-dom/client';
// Work Sans — the askk design-system typeface (Figma). Self-hosted via
// @fontsource so the .woff2 files are bundled & served from our own origin
// (no runtime request to Google Fonts). Only the weights the type tokens and
// component utilities use are imported: 400/500 (tokens), 600/700/800 (font-*).
import '@fontsource/work-sans/400.css';
import '@fontsource/work-sans/500.css';
import '@fontsource/work-sans/600.css';
import '@fontsource/work-sans/700.css';
import '@fontsource/work-sans/800.css';
import './index.css';
import './styles/tokens.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Homepage from './Homepage';
import Policies from './Policies';
import DeleteAccountFaq from './AccountDeletionFaq';
import Terms from './Terms';
import Privacy from './Privacy';
import Community from './Community';
import CoinsPolicy from './CoinsPolicy';
import AccountDeletion from './AccountDeletion';
import GuideTerms from './GuideTerms';
import HoroscopePage from './horoscope/HoroscopePage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <Homepage />
      },
      {
        path: 'policies',
        element: <Policies />
      },
      {
        path: 'terms',
        element: <Terms />
      },
      {
        path: 'privacy',
        element: <Privacy />
      },
      {
        path: 'community',
        element: <Community />
      },
      {
        path: 'coins-policy',
        element: <CoinsPolicy />
      },
      {
        path: 'delete-account-faq',
        element: <DeleteAccountFaq />
      },
      {
        path: 'request-account-delete',
        element: <AccountDeletion/>
      },
      {
        path: 'guide-terms',
        element: <GuideTerms />
      },
      {
        path: 'horoscope',
        element: <HoroscopePage />
      }
    ]
  }
])
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<RouterProvider router={router} />);
reportWebVitals();
